const BONK = ({ ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 2000 2000"
    width="1280"
    height="1280"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(969)"
      d="m0 0h62l40 2 43 4 44 6 44 8 43 10 30 8 39 12 37 13 35 14 32 14 35 17 27 14 23 13 20 12 22 14 12 8 19 13 18 13 21 16 16 13 11 9 13 11 10 9 8 7 13 12 8 8 8 7 16 16 7 8 11 11 7 8 10 11 9 11 13 15 11 14 14 18 13 18 12 17 10 15 11 17 17 28 13 23 15 28 13 26 14 31 16 39 17 48 13 43 12 48 8 39 6 37 5 39 4 51 1 23v62l-2 39-4 44-7 49-7 38-9 40-11 41-14 44-14 38-12 29-13 29-14 29-15 29-14 24-16 27-28 42-10 14-14 19-11 14-13 16-11 13-12 14-12 13-9 10-9 9-7 8-16 16-8 7-10 10-8 7-11 10-11 9-15 13-14 11-18 14-18 13-20 14-15 10-22 14-20 12-23 13-28 15-26 13-31 14-39 16-42 15-35 11-41 11-39 9-38 7-50 7-44 4-39 2h-62l-39-2-44-4-50-7-42-8-47-11-42-12-36-12-38-14-31-13-35-16-28-14-22-12-23-13-23-14-42-28-18-13-19-14-16-13-10-8-13-11-14-12-13-12-10-9-9-9-8-7-16-16-7-8-9-9-7-8-11-12-9-11-13-15-11-14-14-18-13-18-12-17-10-15-11-17-17-28-13-23-15-28-13-26-14-31-16-39-16-45-12-39-11-42-8-36-7-39-6-44-4-43-2-40v-62l2-40 4-43 6-44 8-43 8-36 10-38 14-45 16-44 12-29 12-27 16-33 14-27 14-24 16-27 13-20 17-25 13-18 13-17 11-14 9-11 11-13 9-11 15-16 7-8 10-10 7-8 16-16 8-7 10-10 8-7 12-11 11-9 15-13 14-11 18-14 18-13 17-12 32-21 28-17 23-13 28-15 26-13 31-14 39-16 45-16 39-12 42-11 42-9 33-6 44-6 43-4z"
      fill="#FBDC00"
    />
    <path
      transform="translate(835,502)"
      d="m0 0h13l12 4 14 9 14 12 13 14 11 14 14 19 13 20 15 25 14 25 14 27 8 16 12 25 17-5 12-2h17l12 3 29 13 30 16 24 15 17 12 13 10 16 13 12 11 8 7 21 21 7 8 12 14 13 17 11 15 10 15 15 25 12 22 13 27 11 27 8 22 9 31 5 22-1 3-7-6-14-7-14-4-14-2h-25l-24 3-24 5-29 8-29 10-32 13-24 11-38 19-19 10-33 17-19 10-29 15-19 10-25 13-8 5-6 2-13 1-14-3-14-7-15-9-32-17-33-15-27-10-23-7-24-5-8-1h-29l-15 3-12 5-11 8-8 9-9 15-7 19-3 17v29l3 19 6 21 7 19 12 25 10 17 10 13 28 34 5 6v2l4 2 23 15 18 10 16 8 22 10 28 10 26 8 34 8 36 6 27 3 39 2h16l112-3 80-11 28-4 11-2-7 12-15 23-11 17-16 25-13 20-12 18-9 10-24 26-11 12-11 10-17 12-16 9-17 8-22 7-10 3-11 11-11 9-12 10-21 14-16 9-23 10-19 6-22 5-26 3h-32l-27-3-25-5-25-7-28-10-20-9-21-10-18-10-21-13-22-15-17-13-6-5-33-3-24-5-17-5-21-9-13-7-15-10-11-9-18-18-13-18-11-20-9-23-6-22-4-25-1-11v-57l3-34 6-42 7-37 9-40 11-43 13-44 13-41 15-43 4-10v-12l-2-46v-109l3-50 4-37 6-37 7-30 9-27 5-21 6-15 7-11 9-9 14-7 12-3h19l16 4 12 5 16 9 13 10 14 12 17 17 9 11 11 13 14 19 19 29 14 24 10-4 29-13 7-3 1-80 2-40 3-34 4-30 6-31 7-24 6-16 8-14 4-5 10-10z"
      fill="#E58B18"
    />
    <path
      transform="translate(1281,1054)"
      d="m0 0h25l19 3 16 6 11 7 8 8 9 14 8 18 6 21 3 16 2 28-1 27-4 31-6 28-7 24-5 16-6 23-7 19-12 25-14 21-11 13-9 10-10 9-15 11-21 12-20 8-24 7-42 6-66 9-112 3h-16l-39-2-34-4-33-6-30-7-29-9-25-9-24-11-16-8-21-12-19-13-5-5-11-13-18-22-11-14-10-17-12-23-8-21-6-20-3-15-1-8v-29l3-17 7-19 9-15 9-10 8-6 12-6 11-3 7-1h29l24 4 25 7 28 10 27 12 23 11 22 12 22 13 12 4 13 1 10-2 10-5 22-12 22-11 19-10 50-26 54-28 16-8 19-9 32-13 28-10 27-8 26-6 19-3z"
      fill="#FDFDFD"
    />
    <path
      transform="translate(503,727)"
      d="m0 0h1l-1 23v36l3 38 5 38 7 40 9 42 5 20-1 9-23 65-16 45-22 62-24 128-5 26-2 20v41l3 24 5 22 7 20 10 21 10 15 8 10 11 12 14 12 15 10 18 10 19 8 18 6 24 6 24 4 34 3 33 1 14 12 17 13 18 13 18 12 19 12 21 12 29 15 20 9 26 10 29 9 29 6 26 3h31l27-3-6 7-13 12-14 11-14 10-17 10-16 8-20 8-21 6-21 4-19 2h-32l-27-3-25-5-25-7-28-10-20-9-21-10-18-10-21-13-22-15-17-13-6-5-33-3-24-5-17-5-21-9-13-7-15-10-11-9-18-18-13-18-11-20-9-23-6-22-4-25-1-11v-57l3-34 6-42 7-37 9-40 11-43 13-44 13-41 15-43 4-10v-12l-2-46v-109l3-50 4-37 6-37 7-30z"
      fill="#3C2D0C"
    />
    <path
      transform="translate(1053,255)"
      d="m0 0h26l16 4 10 7 7 10 5 16 2 15 2 40v43l-2 36-4 36-6 30-7 21-6 11-7 8-4 2h-8l-9-6-7-8-9-16-9-20-11-34-8-34-6-36-3-27-1-12-1-36 2-18 5-13 9-10 8-5z"
      fill="#E62E35"
    />
    <path
      transform="translate(1546,497)"
      d="m0 0h15l10 4 8 6 7 7 10 15 7 16 1 5v12l-4 11-7 9-5 6-14 11-17 12-15 10-22 14-24 14-28 15-28 13-25 9-19 5-6 1h-15l-8-3-5-6v-13l5-13 9-16 10-14 9-11 12-14 7-7 7-8 9-9 8-7 13-12 11-9 16-13 18-13 24-16 16-8z"
      fill="#E62D35"
    />
    <path
      transform="translate(1325,303)"
      d="m0 0h13l12 3 21 10 10 8 7 8 4 11v16l-5 19-13 31-11 24-12 25-16 29-16 26-13 18-8 10-9 10-11 11-11 7-9 2-6-2-5-5-4-9-2-11v-37l4-30 7-34 10-35 11-32 11-26 10-21 7-10 6-7 11-7z"
      fill="#E62D35"
    />
    <path
      transform="translate(596,730)"
      d="m0 0h9l12 4 13 9 18 18 15 20 10 15 13 19 11 16 12 17 6 8 3 7 1 12-3 12-6 11-11 12-10 9-19 13-16 9-18 8-13 3-12 1-9-2-7-6-4-11-13-49-7-32-5-30-2-17v-32l3-15 7-14 7-7 9-6z"
      fill="#EFB99D"
    />
    <path
      transform="translate(1252,1085)"
      d="m0 0h22l14 2 14 5 10 9 3 9v30l-4 20-6 18-8 17-16 27-7 8-12 6-4 1h-11l-23-6-22-8-16-7-19-10-16-12-8-8-7-11-3-9v-15l5-13 8-10 8-8 13-9 16-9 24-10 18-4z"
    />
    <path
      transform="translate(868,571)"
      d="m0 0h8l12 6 8 8 12 17 12 20 12 23 17 35 13 23 5 12 1 4v15l-4 9-6 8-14 9-15 5-11 2h-12l-12-3-11-7-8-10-6-14-2-12-8-109v-15l2-16 4-8z"
      fill="#EFB99D"
    />
    <path
      transform="translate(824,960)"
      d="m0 0h16l10 5 7 7 4 8 3 12v15l-4 18-7 16-9 14-11 12-10 8-14 7-10 2-12-1-10-5-6-7-5-10-2-10v-15l4-18 8-18 10-14 10-11 13-9 11-5z"
      fill="#FDFCFC"
    />
    <path
      transform="translate(1143,849)"
      d="m0 0 17 2 13 5 10 6 10 9 6 7 5 9 1 4v10l-4 8-4 5-10 7-15 6-16 3h-25l-18-4-12-5-9-6-7-8-3-8 1-10 6-12 7-8 13-10 13-6 11-3z"
      fill="#FDFDFC"
    />
    <path
      transform="translate(818,515)"
      d="m0 0 1 2-7 16-5 19-3 20-1 11v52l3 35 5 37 6 35 5 27-35 16-8 3v-80l2-40 3-34 4-30 6-31 7-24 6-16 8-14z"
      fill="#3C2D0C"
    />
    <path
      transform="translate(1312,683)"
      d="m0 0h13l12 4 11 8 7 10 4 13v10l-2 9-6 11-9 9-10 5-8 2h-11l-13-4-10-7-7-9-4-9-1-5v-13l3-10 6-10 9-8 11-5z"
      fill="#E62E35"
    />
    <path
      transform="translate(1224,584)"
      d="m0 0h11l13 4 9 7 7 8 4 8 2 9v9l-3 12-6 9-4 5-11 7-10 3h-13l-10-3-10-6-8-9-5-11-1-4v-15l4-11 6-9 7-6 10-5z"
      fill="#E62E35"
    />
    <path
      transform="translate(1078,553)"
      d="m0 0h18l12 5 10 9 6 9 3 10v14l-4 12-6 8-9 8-9 4-4 1h-17l-11-4-9-7-7-9-4-10-1-6v-9l4-13 6-9 8-7 10-5z"
      fill="#E62E35"
    />
    <path
      transform="translate(1147,1028)"
      d="m0 0 19 1 15 4 10 5 5 4 4 8-1 8-4 6-9 8-13 6-15 4-7 1h-26l-17-4-11-6-7-8-1-8 18-3 13-5 8-6 3-5 1-8z"
      fill="#010100"
    />
    <path
      transform="translate(927,1081)"
      d="m0 0h24l15 3 14 7 7 8 1 2v8l-5 8-8 7-13 6-14 4-17 2h-9l-16-2-15-5-8-6-4-5-2-8 1-1 18-3 11-4 9-6 3-5 1-9z"
      fill="#010100"
    />
  </svg>
);
export default BONK;
